export enum Status {
  Empty = 0, // no icon
  Ok = 1, // green check icon
  Error = 2, // red error icon
  Check = 3 // yellow warning triangle
}
export enum PeriodStatus {
  Open = 1,
  Closed = 2
}

export enum CalendarRange {
  Monthly = 'month',
  Weekly = 'week',
  Yearly = 'year',
  Daily = 'day'
}

export enum EventType {
  Version = 1,
  Comment = 2
}

export enum ValidationType {
  Success = 1,
  Error = 2,
  Check = 3
}

export enum EditKpiStatus {
  Success = 0,
  VersionConcurrencyFail = 1,
  ValidationFail = 2,
  NotUpdated = 3,
  NetHeatValueValidationFail = 4
}

export enum DailyReportApproveStatus {
  Success = 1,
  Failed = 2,
  PeriodClosed = 3,
  CannotApproveDueToValidationErrors = 4,
  ProcessFailed = 5
}

export enum MonthlyReportApproveStatus {
  Success = 1,
  Failed = 2,
  PeriodClosed = 3,
  ValidationFailedForSelectedPeriod = 4
}

export enum SaveButtonState {
  Disabled = 0,
  Changed = 1,
  Saved = 2,
  Hidden = 3
}

export enum WarningMessage {
  NoDataFor3Days = 1,
  FillDataReminder = 2,
  DataOverDue = 3,
  PlantInfoMessage = 4
}

export enum PeriodStatusRange {
  Monthly = 1,
  Yearly = 2
}

export enum MonthsFilterOptions {
  Month = 1,
  Quarter = 2,
  HalfYear = 3,
  Year = 4
}

export enum MonthlyDataType {
  All = 1,
  Autofilled = 2,
  Manual = 3,
  Missing = 4
}

export enum CompareToOptions {
  OriginalPlan = 'originalPlan'
}

export enum KpiValueType {
  Planned,
  Forecast,
  Actual
}

export enum PageShowOptions {
  PL = 0,
  ACFC = 1,
  AC = 2
}

export enum ValueApplicableTypes {
  Planning = 1,
  Forecast = 2,
  PlanningAndForecast = Planning | Forecast, // 3
  Actual = 4,
  ActualAndPlanning = Planning | Actual, // 5
  ForecastAndActual = Forecast | Actual, // 6
  ForecastAndActualAndPlanning = Planning | Forecast | Actual, // 7
  FA = 8,
  FJ = 16,
  FO = 32,
  FC0 = 64,
  ALL = Planning | Forecast | Actual | FA | FJ | FO | FC0 // 127
}

export enum ForecastPeriodType {
  FA = 'FA',
  FJ = 'FJ',
  FO = 'FO'
}

export type ForecastPeriod = keyof typeof ForecastPeriodType

export enum UnitType {
  Numeric = 1,
  Time = 2,
  Text = 3, // Not summable type
  Percentage = 4,
  Gigajoule = 5,
  Empty = 23 // Not summable type
}

export enum WaterMeasureType {
  Actual = 1,
  Estimated = 2,
  Metered = 3,
  Other = 4
}

export enum PlantStructureFilterOptions {
  All = 'all',
  Storages = 'storages',
  Planner = 'planner',
  Janus = 'janus'
}

export enum ValueRelationToDefault {
  LessThanDefault = 1,
  EqualToDefault = 2,
  GreaterThanDefault = 3
}

export enum PeriodType {
  Daily = 1,
  Monthly = 2,
  PSS = 3
}

export enum ReportType {
  Daily = 1,
  Monthly = 2,
  CumulativeDaily = 3,
  PSS = 4
}

export enum ValueValidationMessageStatuses {
  Pending = 1,
  Resolved = 2
}

export enum ValueValidationStatuses {
  Pending = 1,
  Valid = 2,
  Error = 3,
  Blockage = 4,
  Justified = 5,
  Warning = 6
}

export enum ValidationRuleTypes {
  Validation = 1,
  Check = 2
}

export enum ValidationRuleScopes {
  Daily = 1,
  Pss = 2,
  Monthly = 3,
  CheckReport = 4
}

export enum ValidationTabValues {
  All = 'all',
  Daily = 'daily',
  Monthly = 'monthly',
  Pss = 'pss',
  CheckReports = 'checkReports'
}

export enum TriStateValue {
  False = 1,
  True = 2,
  Mixed = 3
}

export enum SegmentType {
  Text = 1,
  Input = 2
}

export enum KpiLimitTypes {
  LowerLimit = 1,
  UpperLimit = 2,
  UpperTotalLimit = 3
}
